<script>
import { mapActions, mapGetters } from 'vuex';
import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Clinical Research Categories'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Clinical Research Categories'
        };
    },

    computed: {
        ...mapGetters({
            ALL_TYPES: 'clinicalResearchCategories/ALL_TYPES',
            ALL_STATUSES: 'clinicalResearchCategories/ALL_STATUSES'
        }),

        labels() {
            return [
                {
                    value: 'title',
                    width: '150px'
                },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'type',
                    width: '150px',
                    type: 'enum',
                    enumOptions: this.ALL_TYPES
                },
                {
                    value: 'status',
                    type: 'enum',
                    enumOptions: this.ALL_STATUSES
                },
                {
                    value: 'createdBy.fullName',
                    sortFieldName: 'createdBy.firstName',
                    text: 'Created By',
                    width: '110px'
                },
                {
                    value: 'editedBy.fullName',
                    sortFieldName: 'editedBy.firstName',
                    text: 'Edited By',
                    width: '110px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '100px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '100px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'clinicalResearchCategories/index',
            deleteItem: 'clinicalResearchCategories/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/clinical-research-categories/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/clinical-research-categories/add');
        }
    }
};
</script>
